import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import TopLeftTransition from '../../assets/img/section-transitions/about-top-left.svg'
import { useTranslation } from 'react-i18next'

const About = () => {
    const { t } = useTranslation();
    
    const handleScroll = (event: React.MouseEvent) => {
        event.preventDefault();
        const aboutSection = document.getElementById('jak-to-funguje');
        if (aboutSection) {
            aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div id='jak-to-funguje' className='py-35 relative'>
            <img 
                src={TopLeftTransition} 
                alt="Transition Effect" 
                width={326}
                height={75}
                className="absolute top-0 left-0 w-[30%] max-w-[400px] z-10"
            />

            <a href="#jak-to-funguje" className='absolute top-4 left-1/2 transform -translate-x-1/2 text-5xl p-3' onClick={handleScroll} aria-label="Scroll to section Jak to funguje">
                <FontAwesomeIcon icon={faAngleDown} className='arrow-bounce' />
            </a>
            <div className="mx-auto h-full flex flex-col items-center justify-center text-center"
                style={{ maxWidth: "var(--width-container)" }}>
                    <p className='font-medium sm:text-[34px] max-w-[940px]'>
                        {t('about.description')}
                    </p>
                    <p className='max-w-[592px] mt-[58px] text-[18px]'>
                        {t('about.features.description')}
                    </p>
                    <div className='bg-primary-background mt-31 py-10 px-20 max-w-[752px] text-xl rounded-xl'>
                        {t('about.features.title')}
                    </div>
            </div>
        </div>
    )
}

export default About
